<template>
  <div class="d-flex flex-column">
    <div class="row justify-content-between">
      <div class="col-12 col-sm-4 d-flex">
        <card :title="$t('sections.pmLandingPage.numbers.title')" divider>
          <div class="row">
            <div class="d-flex flex-column col-auto">
              <HorizontalDetailTitle
                :label="$t('sections.pmLandingPage.numbers.totalEntities')"
              />
              <HorizontalDetailTitle
                :label="$t('sections.pmLandingPage.numbers.totalEntitiesOCPI')"
              />
              <HorizontalDetailTitle
                :label="$t('sections.pmLandingPage.numbers.totalCEME')"
              />
              <HorizontalDetailTitle
                :label="$t('sections.pmLandingPage.numbers.totalCPO')"
              />
              <HorizontalDetailTitle
                :label="$t('sections.pmLandingPage.numbers.totalFrontendUsers')"
              />
              <HorizontalDetailTitle
                :label="
                  $t('sections.pmLandingPage.numbers.totalBackofficeUsers')
                "
              />
            </div>
            <div class="d-flex flex-column col-auto flex-fill pl-4">
              <HorizontalDetailInput
                :field="entitiesTotalCount"
                :edit="false"
              />
              <HorizontalDetailInput :field="emspCount" :edit="false" />
              <HorizontalDetailInput :field="cpoCount" :edit="false" />
              <HorizontalDetailInput :field="ocpiCount" :edit="false" />
              <HorizontalDetailInput
                :field="frontendUsersCount"
                :edit="false"
              />
              <HorizontalDetailInput
                :field="backofficeUsersCount"
                :edit="false"
              />
            </div>
          </div>
        </card>
      </div>
      <div class="col-12 col-sm-8">
        <BarChart
          v-if="!getLoading"
          :labels="$t('sections.pmLandingPage.barGraph.labels')"
          :datasets="graphDatasets"
          :title="$t('sections.pmLandingPage.barGraph.dataLabel')"
          class="mb-3"
        />
      </div>
    </div>
    <span class="section-title" v-if="alarmsPermissions.read">
      {{ $t("sections.pmLandingPage.table.title") }}
    </span>
    <PaginationWrapper
      :page="page"
      :totalCount="totalCount"
      @onPageChange="handlePageChange"
      export
      @exportTable="exportList"
      v-if="alarmsPermissions.read"
    >
      <!-- <div slot="table">
        <base-table :data="getAlarms">
          <el-table-column
            prop="id"
            :label="$t('sections.pmLandingPage.table.id')"
          />
          <el-table-column fixed="right" width="60">
            <template slot="header">
              <div class="button-placeholder" />
            </template>
            <template slot-scope="props">
              <div class="d-flex justify-content-center">
                <el-dropdown trigger="click">
                  <div class="outline-icon-button">
                    <font-awesome-icon icon="fa-regular fa-ellipsis-vertical" />
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <router-link
                        :to="{
                          name: 'Alarm Detail',
                          params: {
                            id: props.row.id,
                            alarm: props.row,
                          },
                        }"
                      >
                        {{ $t("sections.alarms.options")[0] }}
                      </router-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </base-table>
      </div> -->

       <AlarmsSearchOptions @onSearch="handleSearch" slot="search-options" :modules=false />
      <AlarmsTable slot="table" />
    </PaginationWrapper>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';
import BarChart from '@/components/ui/charts/BarChart.vue';
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import AlarmsTable from '@/components/sections/alarms/AlarmsTable';
import AlarmsSearchOptions from '@/components/sections/alarms/AlarmsSearchOptions';

export default {
  name: 'PlatformManagerLandingPage',
  components: {
    HorizontalDetailTitle,
    HorizontalDetailInput,
    BarChart,
    PaginationWrapper,
    AlarmsTable,
    AlarmsSearchOptions,
  },
  data() {
    return {
      entitiesTotalCount: 0,
      emspCount: 0,
      cpoCount: 0,
      ocpiCount: 0,
      frontendUsersCount: 0,
      backofficeUsersCount: 0,
      entitiesCountByType: [],
      page: 1,
      totalCount: 0,
      query: {},
    };
  },
  computed: {
    ...mapGetters(['getLoading', 'getAlarms', 'getPagePermissions']),
    alarmsPermissions() {
      return this.getPagePermissions('Alarms Manager - Alarms');
    },
    graphDatasets() {
      return [
        {
          label: this.$t('sections.pmLandingPage.barGraph.dataLabel'),
          borderColor: '#1a84cf',
          backgroundColor: 'rgba(26, 132, 207, 0.5)',
          data: this.entitiesCountByType,
        },
      ];
    },
  },
  mounted() {
    this.fetchData();
    this.fetchAlarmsData();
  },
  methods: {

    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchAlarmsData();
    },
    async fetchAlarmsData() {
      this.$store.dispatch('storeLoading', true);
      this.totalCount = await this.$store.dispatch('storeAlarms', {
        query: {
          ...this.query,
          module: 'Platform Manager',
        },
        page: this.page,
      });
      this.$store.dispatch('storeLoading', false);
    },

    async fetchData() {
      this.$store.dispatch('storeLoading', true);

      try {
        const entitiesCount = await this.$store.dispatch(
          'getEntitiesAnalytics',
        );

        this.entitiesTotalCount = entitiesCount.entitiesTotalCount;
        this.emspCount = entitiesCount.emspCount;
        this.cpoCount = entitiesCount.cpoCount;
        this.ocpiCount = entitiesCount.ocpiCount;

        this.entitiesCountByType.push(entitiesCount.frontendMobieCount);
        this.entitiesCountByType.push(entitiesCount.frontendEmspCount);
        this.entitiesCountByType.push(entitiesCount.frontendCpoCount);
        this.entitiesCountByType.push(entitiesCount.frontendOrdCount);
        this.entitiesCountByType.push(entitiesCount.frontendDpcCount);
        this.entitiesCountByType.push(entitiesCount.frontendCseCount);
        this.entitiesCountByType.push(entitiesCount.frontendMunCount);
        this.entitiesCountByType.push(entitiesCount.frontendOthCount);
      } catch (e) {
        console.log("Couldn't get entities analytics.");
      }

      try {
        const usersCount = await this.$store.dispatch('getUsersAnalytics');

        this.frontendUsersCount = usersCount.frontend;
        this.backofficeUsersCount = usersCount.backoffice;
      } catch (e) {
        console.log("Couldn't get users analytics.");
      }

      this.$store.dispatch('storeLoading', false);
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: this.query,
          type: 'alarms',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', { type: 'alarms' }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `alarms-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'alarms' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'alarms' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
